import { data } from '../../svg/PriceMapping/data';
import { makeIcon } from '../makeIcon';

export const PriceMapping = makeIcon(data, 'price_mapping', 'PriceMapping');

export default PriceMapping;
